import type { ReactNode } from 'react';

/** 网卡配置在业务表单中的固定字段路径。 */
export const NIC_CONFIGURATION_FIELD = 'network.nics' as const;

/** 网卡资源配置接口中的单个可调度网卡。 */
export interface NicResourceQuantity {
  min?: number;
  max?: number;
  total?: number;
  resourceName: string;
  networkAttachmentDefinition?: string;
  nic?: {
    cidrBlocks?: string[];
  };
}

/** 网卡资源配置接口返回项。 */
export interface NicResourceConfiguration {
  type: string;
  /** 网卡类型，例如 RoCE；资源配置页面按该字段分组展示。 */
  deviceType?: string;
  vendor: string;
  vendorID: string;
  device: string;
  deviceID: string;
  resourceType: string;
  architecture?: string;
  quantities?: NicResourceQuantity[];
  nic?: {
    linkSpeed?: string;
    linkType?: string;
  };
}

/** 提交到 network.nics[].resource 的单个网卡资源。 */
export interface NicResource {
  quantity: {
    limit: string;
    request: string;
  };
  networkAttachmentDefine?: string;
  cidrBlocks: string[];
}

/** 提交到 network.nics 的单个网卡配置。 */
export interface NicConfigurationItem {
  /** 网卡类型，例如 RoCE。 */
  deviceType?: string;
  vendor: string;
  vendorID: string;
  device: string;
  deviceID: string;
  resourceType: string;
  linkSpeed?: string;
  linkType?: string;
  resource: Record<string, NicResource>;
}

/** 网卡配置组件固定输出的表单值。 */
export type NicConfigurationValue = NicConfigurationItem[];

/** 用于筛选某类网卡库存的厂商设备标识。 */
export interface NicVendorDeviceSelection {
  vendor?: string;
  vendorID?: string;
  device?: string;
  deviceID?: string;
}

/** 网卡配置组件受控属性；不开放请求和查询参数覆盖能力。 */
export interface NicConfigurationProps {
  value?: NicConfigurationValue;
  onChange?: (value: NicConfigurationValue) => void;
  /** 卡片内的厂商设备选择区；传入后替换默认连接信息，并按选中厂商设备筛选网段。 */
  renderVendorDeviceSelector?: (deviceType: string) => ReactNode;
  /** 返回指定网卡类型当前选中的厂商设备。 */
  getSelectedVendorDevice?: (deviceType: string) => NicVendorDeviceSelection | undefined;
  /** 只读：禁止勾选/取消网段（固定规格下单整块只读） */
  readOnly?: boolean;
}
